import React from 'react';
import { i18n } from 'utils/i18n';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import LimitedInventoryVehicleModalContent from 'components/ReservationFlow/VehicleSelect/Modals/LimitedInventoryVehicleModalContent';

const LimitedInventoryVehicleModal = () => (
  <Modal
    modalKey={MODAL.LIMITED_INVENTORY_VEHICLE_MODAL}
    header={i18n('limited_inventory_vehicle_modal_title')}
    theme={MODAL_THEMES.WHITE}
    customClass='limited_inventory__modal'
  >
    <LimitedInventoryVehicleModalContent />
  </Modal>
);

export default LimitedInventoryVehicleModal;
